import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.5 2.28',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M.27,2.05A.27.27,0,0,1,0,1.78V.5A.27.27,0,0,1,.54.5V1.78A.27.27,0,0,1,.27,2.05Zm0-1.7A.15.15,0,0,0,.12.5V1.78a.15.15,0,0,0,.15.15.15.15,0,0,0,.15-.15V.5A.15.15,0,0,0,.27.35Z"
        />
        <path
          fill={fill}
          d="M3.23,2.05A.27.27,0,0,1,3,1.78V.5A.27.27,0,0,1,3.5.5V1.78A.27.27,0,0,1,3.23,2.05Zm0-1.7A.15.15,0,0,0,3.08.5V1.78a.15.15,0,0,0,.3,0V.5A.15.15,0,0,0,3.23.35Z"
        />
        <path
          fill={fill}
          d="M.69,2.28A.27.27,0,0,1,.42,2V.27A.27.27,0,0,1,1,.27V2A.27.27,0,0,1,.69,2.28ZM.69.12A.15.15,0,0,0,.54.27V2a.15.15,0,0,0,.15.15A.15.15,0,0,0,.84,2V.27A.15.15,0,0,0,.69.12Z"
        />
        <path
          fill={fill}
          d="M2.81,2.28A.27.27,0,0,1,2.54,2V.27a.27.27,0,0,1,.54,0V2A.27.27,0,0,1,2.81,2.28Zm0-2.16a.15.15,0,0,0-.15.15V2A.15.15,0,1,0,3,2V.27A.15.15,0,0,0,2.81.12Z"
        />
        <path
          fill={fill}
          d="M2.6,1.41H.9a.06.06,0,0,1-.06-.06V.93A.06.06,0,0,1,.9.87H2.6a.06.06,0,0,1,.06.06v.42A.06.06,0,0,1,2.6,1.41ZM1,1.29H2.54V1H1Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
